// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__Ow3v5","modal":"Modal_modal__yEgVW","close":"Modal_close__nnot4"};